import { Helmet } from 'react-helmet';
import ContactForm from '../components/ContactForm';

export default function ContactPage() {
  return (
    <>
      <Helmet>
        <title>Contact Us | The Prisu Experts</title>
        <meta
          name="description"
          content="Get in touch with The Prisu Experts to discuss your data project needs for AI and machine learning."
        />
      </Helmet>
      <ContactForm />
    </>
  );
}
